/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ChannelGetResponse } from '../api-models';
// @ts-ignore
import { ChatUserResponse } from '../api-models';
// @ts-ignore
import { NewChatRequest } from '../api-models';
/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {NewChatRequest} [newChatRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatStartChatPost: async (newChatRequest?: NewChatRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat/start-chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets chat token for individual user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatTokenGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {NewChatRequest} [newChatRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatStartChatPost(newChatRequest?: NewChatRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatStartChatPost(newChatRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets chat token for individual user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatTokenGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatTokenGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * 
         * @param {ChatApiChatStartChatPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatStartChatPost(requestParameters: ChatApiChatStartChatPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ChannelGetResponse> {
            return localVarFp.chatStartChatPost(requestParameters.newChatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets chat token for individual user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatTokenGet(options?: AxiosRequestConfig): AxiosPromise<ChatUserResponse> {
            return localVarFp.chatTokenGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for chatStartChatPost operation in ChatApi.
 * @export
 * @interface ChatApiChatStartChatPostRequest
 */
export interface ChatApiChatStartChatPostRequest {
    /**
     * 
     * @type {NewChatRequest}
     * @memberof ChatApiChatStartChatPost
     */
    readonly newChatRequest?: NewChatRequest
}

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * 
     * @param {ChatApiChatStartChatPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatStartChatPost(requestParameters: ChatApiChatStartChatPostRequest = {}, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatStartChatPost(requestParameters.newChatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets chat token for individual user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatTokenGet(options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatTokenGet(options).then((request) => request(this.axios, this.basePath));
    }
}
